import { useQuery } from "@tanstack/react-query";
import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { useApi } from "@/lib/api";

const tick = (d) => new Date(d + "T00:00:00").toLocaleDateString("en-US", { month: "short", day: "numeric" });

export const UsageChart = () => {
  const api = useApi();
  const { data } = useQuery({ queryKey: ["usage-history"], queryFn: () => api.get("/usage/history") });
  const { data: today } = useQuery({ queryKey: ["ai-usage"], queryFn: () => api.get("/ai/usage") });
  return (
    <section data-testid="usage-dashboard" className="mt-10 max-w-4xl rounded-xl border border-[#2A2A2A] bg-[#121212] p-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h3 className="font-display text-lg">Usage, last 30 days</h3>
          <p className="text-sm text-[#A3A3A3]">Calibrator questions and board email sends per day.</p>
        </div>
        <div className="grid grid-cols-3 gap-4 sm:gap-6 font-mono text-xs sm:text-sm">
          <p data-testid="usage-total-questions" className="flex flex-col"><span className="text-[#D9A6FF] text-xl">{data?.totals.questions ?? "…"}</span> questions</p>
          <p data-testid="usage-total-board" className="flex flex-col"><span className="text-[#00FF9D] text-xl">{data?.totals.board_sends ?? "…"}</span> board sends</p>
          {today && <p data-testid="usage-today" className="flex flex-col"><span className="text-white text-xl">{today.left}/{today.limit}</span> left today</p>}
        </div>
      </div>
      <div className="mt-6 h-64" data-testid="usage-chart">
        {data && (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data.series} margin={{ left: -20, right: 8 }}>
              <CartesianGrid stroke="#1E1E1E" vertical={false} />
              <XAxis dataKey="day" tickFormatter={tick} tick={{ fill: "#6B6B6B", fontSize: 11 }} interval={6} axisLine={false} tickLine={false} />
              <YAxis allowDecimals={false} tick={{ fill: "#6B6B6B", fontSize: 11 }} axisLine={false} tickLine={false} />
              <Tooltip cursor={{ fill: "rgba(255,255,255,0.04)" }} labelFormatter={tick}
                contentStyle={{ background: "#0A0A0A", border: "1px solid #2A2A2A", borderRadius: 8, fontSize: 12 }} />
              <Legend wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="questions" name="Calibrator questions" fill="#9D00FF" radius={[3, 3, 0, 0]} minPointSize={0} maxBarSize={14} />
              <Bar dataKey="board_sends" name="Board sends" fill="#00FF9D" radius={[3, 3, 0, 0]} maxBarSize={14} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </section>
  );
};
